<template>
  <modal :show.sync="modals.classic">
    <h4 slot="header" class="title title-up">
      {{ $t("app.modules.documentTypes.edit.title") }}
    </h4>
    <ValidationObserver ref="formEdit" v-slot="{ handleSubmit }">
      <form @submit.prevent="handleSubmit(submitEditType)">
        <div class="row text-left">
          <div
            :class="sizes"
            v-for="lang in item.traducciones"
            :key="lang.idLenguaje"
          >
            <ValidationProvider
              :name="$t('app.modules.documentTypes.headers.name')"
              rules="required"
              v-slot="{ passed, failed }"
            >
              <fg-input
                type="text"
                :error="failed ? required_text : null"
                :hasSuccess="passed"
                :placeholder="lang.idioma"
                :label="$t('app.modules.documentTypes.headers.name')"
                v-model="lang.descripcion"
              >
              </fg-input>
            </ValidationProvider>
          </div>
        </div>
        <div class="col-sm-6 form-group has-label">
          <div style="margin-bottom: -5px; margin-left: -12px;">
            <label>{{ $t("app.general.state") }}</label>
          </div>
          <template>
            <n-switch v-model="item.activo">
              <i class="now-ui-icons ui-1_check" slot="on"></i>
              <i class="now-ui-icons ui-1_simple-remove" slot="off"></i>
            </n-switch>
          </template>
        </div>
        <div
          slot="footer"
          style="margin-top: 10px; padding-top: 20px;border-top: outset;"
          class="text-right"
        >
          <n-button class="pull-left btn-secondary" @click.native="cancelEdit()">{{
            $t("app.buttons.cancel")
          }}</n-button>
          <n-button native-type="submit" type="primary">{{
            $t("app.buttons.save")
          }}</n-button>
        </div>
      </form>
    </ValidationObserver>
  </modal>
</template>
<script>
import { mapState } from "vuex";
export default {
  components: {},
  data() {
    return {
      required_text: this.$t("app.general.required"),
      sizes: "col-md-6 col-sm-12",
      item: {
        idTipoDocPedido: 0,
        nombre: "",
        activo: true,
        accion: "Alta",
        usuariosIdUsuario: 0,
        fecha: "2020-11-10T15:30:46.239Z"
      },
      modals: {
        classic: false
      }
    };
  },
  computed: {
    ...mapState(["user"])
  },
  created() {
    this.item.usuariosIdUsuario = this.user.idUsuario;
  },
  mounted() {
    EventBus.$on("document-type-edit", async item => {
      this.$swal.fire({
        title: this.$t("app.promps.wait"),
        html:
          '<div class="spinner-border text-primary" style="width: 3rem; height: 3rem;" role="status"><span class="sr-only">Loading...</span></div>',
        showConfirmButton: false
      });
      this.$swal.close();
      this.item = item;
      this.modals.classic = true;
    });
  },
  methods: {
    async submitEditType() {
      this.item.usuariosIdUsuario = this.user.idUsuario;
      this.item.accion = "Cambio";
      console.log(this.item);
      await this.$http
        .put(route("TipoDocumentoPedido/updateTipoDocumentoPedido"), this.item)
        .then(
          async response => {
            if (response.body.code === 200) {
              this.notifyMessage("success", this.$t("app.promps.save_success"));
              EventBus.$emit("reload-items-tiposdocu");
              this.cancelEdit();
            } else {
              this.notifyMessage("danger", this.$t("app.promps.error"));
            }
          },
          error => {
            this.trubbleSave = true;
            this.notifyMessage("danger", this.$t("app.promps.error"));
          }
        )
        .finally(() => {});
    },
    cancelEdit() {
      this.$refs.formEdit.reset();
      this.item.nombre = "";
      this.modals.classic = false;
    }
  }
};
</script>
<style>
.extended-forms .el-select {
  width: 100%;
  margin-bottom: 30px;
}
.card .alert {
  position: relative !important;
  width: 100%;
}

.modal-content .modal-header {
  padding-bottom: 24px;
  box-shadow: 0px 2px 5px 0px #00000021;
}

.modal-content .modal-body + .modal-footer {
  padding-top: 20px !important;
  background-color: #efefefb3;
}
</style>
